import React from 'react';
import { useLanguage } from './LanguageContext';
export const Hero = () => {
  const {
    t
  } = useLanguage();
  const scrollTo = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section id="home" className="relative w-full h-screen min-h-[640px] overflow-hidden" data-id="element-146">
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/kVQgSWYESh3qPXKbsPF36B/Banner_2_Girls.png")'
    }} data-id="element-147" />

      {/* Navy Gradient Overlay */}
      <div className="absolute inset-0 w-full h-full" style={{
      background: 'linear-gradient(to right, rgba(27, 43, 94, 0.92) 0%, rgba(27, 43, 94, 0.75) 40%, rgba(27, 43, 94, 0.30) 70%, rgba(27, 43, 94, 0.05) 100%)'
    }} data-id="element-148" />

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-5 sm:px-6 lg:px-8 h-full flex flex-col justify-center pt-[100px] md:pt-20" data-id="element-149">
        <div className="max-w-2xl w-full" data-id="element-150">
          {/* Trust Badge — hidden on mobile per spec */}
          <div className="hidden sm:inline-block rounded-[20px] px-4 py-1.5 mb-6 backdrop-blur-[8px]" style={{
          background: 'rgba(201,168,76,0.15)',
          border: '1px solid rgba(201,168,76,0.60)'
        }} data-id="element-151">
            <span className="text-brand-gold font-montserrat font-medium text-[12px] tracking-[2px]" data-id="element-152">
              {t('hero.badge')}
            </span>
          </div>

          {/* Headlines */}
          <h1 className="font-montserrat font-extrabold text-[36px] md:text-[58px] leading-[1.15] mb-5 md:mb-6" data-id="element-153">
            <span className="text-brand-gold" data-id="element-154">{t('hero.title1')}</span>
            <br data-id="element-155" />
            <span className="text-white" data-id="element-156">{t('hero.title2')}</span>
          </h1>

          {/* Subheadline */}
          <p className="font-inter text-[15px] md:text-[18px] text-white/85 mb-8 md:mb-10 max-w-xl leading-relaxed" data-id="element-157">
            {t('hero.sub')}
          </p>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 mb-10 md:mb-12" data-id="element-158">
            <button onClick={() => scrollTo('contact')} className="bg-brand-gold hover:bg-white hover:scale-[1.03] transition-all duration-300 text-brand-navy hover:text-brand-navy font-montserrat font-extrabold h-[54px] md:h-[56px] w-full sm:w-auto px-6 md:px-8 rounded-[28px] shadow-gold flex items-center justify-center text-[15px] md:text-[16px] whitespace-nowrap" data-id="element-159">
              {t('hero.btn1')}
            </button>
            <button onClick={() => scrollTo('services')} className="bg-transparent hover:bg-brand-gold hover:text-brand-navy border-2 border-brand-gold/70 transition-all duration-300 text-white font-inter font-semibold h-[54px] md:h-[56px] w-full sm:w-auto px-6 md:px-8 rounded-[28px] flex items-center justify-center text-[15px] md:text-[16px] whitespace-nowrap" data-id="element-160">
              {t('hero.btn2')}
            </button>
          </div>

          {/* Micro Trust Bar — 2x2 grid on mobile, row on desktop */}
          <div className="grid grid-cols-2 sm:flex sm:flex-row gap-3 sm:gap-6 max-w-md sm:max-w-none" data-id="element-161">
            {[t('hero.trust1'), t('hero.trust2'), t('hero.trust3')].map((text, i) => <div key={i} className="flex items-center gap-2" data-id="element-162">
                  <span className="text-brand-gold text-lg leading-none flex-shrink-0" data-id="element-163">
                    ✦
                  </span>
                  <span className="text-white font-inter font-medium text-[12px] sm:text-[13px]" data-id="element-164">
                    {text}
                  </span>
                </div>)}
          </div>
        </div>
      </div>
    </section>;
};